import './App.css';
//import ItensProdutos from "./Componentes/Cabecalho/ItensProdutos.js";
//import Menu from "./Componentes/Cabecalho/Menu.js"
import Rodape from "./Componentes/Rodape/Rodape.js";
import Produtos from "./Paginas/Produtos/Produtos.js";
import Clientes from "./Paginas/Clientes/Clientes.js";
import QuemSomos from "./Paginas/QuemSomos/QuemSomos.js";
import Eventos from "./Paginas/Eventos/Eventos.js";
import Contato from "./Paginas/Contato/Contato.js";
//import InicioProdutos from "./Paginas/Produtos/Inicio.js";
import Home from "./Paginas/Home/Home.js";
import {  BrowserRouter as Router,  Routes,  Route} from "react-router-dom";
import Menu from "./Componentes/Cabecalho/Menu.js";
import Carregando from "./Componentes/Carregando.js";
//import Impressao from './Componentes/Cabecalho/Impressao.js';

function App() {
  return (
    <div className="App">
      {/* <Router> */}
        {/* <ItensProdutos></ItensProdutos> */}
        <Carregando></Carregando>
        <Menu></Menu>
        {/* <Impressao></Impressao> */}
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/produtos' element={<Produtos/>} />
          <Route path='/produtos/:idCategoria?' element={<Produtos/>} />
          <Route path='/produtos/:idCategoria/:idProduto' element={<Produtos/>} />
          <Route path='/clientes' element={<Clientes/>} />
          <Route path='/quem-somos' element={<QuemSomos/>} />
          <Route path='/eventos' element={<Eventos/>} />
          <Route path='/contato' element={<Contato/>} />
        </Routes>
        <Rodape></Rodape>
    {/* </Router> */}
    </div>
  );
}

export default App;
